import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { StarIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { useHighlightText } from './hooks/useHighlightText';

type Props = {
	text: string;
	selected: boolean;
};

export const HighlightText: React.FC<Props> = ({ text, selected }) => {
	const {
		data: {
			pillBackgroundClass,
			selectedPillBackgroundClass,
			bandBackgroundClass,
			selectedBandBackgroundClass,
			textClass,
			selectedTextClass,
			iconClass,
			selectedIconClass,
		},
	} = useHighlightText();

	return (
		<div
			className={cn(
				'-mb-px flex items-center justify-start rounded-t-[11px] px-6 pt-4 text-center',
				selected ? selectedBandBackgroundClass : bandBackgroundClass,
			)}
		>
			<div
				className={cn(
					'flex items-center justify-center gap-1 rounded-full px-2 py-1',
					selected ? selectedPillBackgroundClass : pillBackgroundClass,
				)}
			>
				<StarIcon
					size="x-small"
					data-qa="ppmu-modal-highlight-icon"
					className={selected ? selectedIconClass : iconClass}
				/>
				<Text
					variant="body"
					size="x-small"
					fontWeight="bold"
					data-qa="ppmu-modal-highlight-text"
					className={selected ? selectedTextClass : textClass}
				>
					{text}
				</Text>
			</div>
		</div>
	);
};
